import { render, staticRenderFns } from "./processPopup.vue?vue&type=template&id=13c1eac0&scoped=true&"
import script from "./processPopup.vue?vue&type=script&lang=js&"
export * from "./processPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c1eac0",
  null
  
)

export default component.exports